module.exports = __webpack_public_path__ + "media/images/photo/plans/shooting-spots/list-icon-b58458a94da1576b07f2a7e943b22084.png";